export default "__VITE_ASSET__a0dafd87__"